import { useState } from 'react';

import type { AiRun } from '@/api/types';
import { formatDateTime } from '@/ui/format';
import { Modal } from '@/ui/Modal';

import { formatDuration, statusStyle } from './usageLists';

/** A failed or refused run's full error, with the context to place it. */
export function RunErrorDialog({
  run,
  processLabel,
  utc,
  onClose,
}: {
  run: AiRun;
  processLabel: string;
  utc: boolean;
  onClose: () => void;
}) {
  const status = statusStyle(run.status);
  const [copied, setCopied] = useState(false);
  return (
    <Modal
      title={`${status.label} run`}
      subtitle={`${processLabel} · ${formatDateTime(run.created_at, utc)}${utc ? ' UTC' : ''}`}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() =>
              void navigator.clipboard?.writeText(run.error ?? '').then(
                () => setCopied(true),
                () => setCopied(false),
              )
            }
          >
            {copied ? 'Copied' : 'Copy error'}
          </button>
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Close
          </button>
        </>
      }
    >
      <dl className="run-detail">
        <dt>Model</dt>
        <dd>{run.model_name ?? 'Not recorded'}</dd>
        <dt>Who</dt>
        <dd>{run.user_name ?? 'System'}</dd>
        <dt>Duration</dt>
        <dd>{formatDuration(run.latency_ms)}</dd>
        <dt>Status</dt>
        <dd><span className={`badge ${status.className}`}>{status.label}</span></dd>
      </dl>
      <pre className="text-preview" tabIndex={0}>{run.error}</pre>
    </Modal>
  );
}
